import antdSA from "antd/lib/locale-provider/fr_FR";
import appLocaleData from "react-intl/locale-data/fr";
import saMessages from "../locales/fr_FR.json";

const allMessages = { ...saMessages };

const saLang = {
  messages: {
    ...allMessages,
  },
  antd: antdSA,
  locale: "fr-FR",
  data: appLocaleData,
};
export default saLang;
